import { Navigate, Routes, Route } from 'react-router-dom'
import { useAuthContext } from '../hooks/useAuthContext'
import MyTasks from '../pages/Dashboard/MyTasks'
import MyProcesses from '../pages/Dashboard/MyProcesses'
import ProcessDashboard from '../pages/Dashboard/ProcessDashboard'
import ReportView from '../components/Report/ReportView'
import MyQueries from '../pages/Dashboard/MyQueries'
import DataEntryPage from '../pages/DataEntryPage/DataEntryPage'
import Monitoring from '../pages/Iot/Em/Monitoring'
import Utilization from '../pages/Iot/Em/Utilization'
import Config from '../pages/Iot/Em/Config'
import Views from '../custom-reporting-views/Views'
import Layout from '../components/Header/Layout'
import MyRulesets from '../pages/Dashboard/MyRulesets'

const UserRoutes = () => {
  const { user } = useAuthContext()

  return (
    <Layout>
      <Routes>
        <Route path="/tasks" element={!user ? <Navigate to={'/login'} /> : <MyTasks />} />
        <Route path="my-processes" element={!user ? <Navigate to={'/login'} /> : <MyProcesses />} />
        <Route
          path="my-views/:reporting_view_slug_or_id"
          element={!user ? <Navigate to={'/login'} /> : <Views />}
        />
        <Route path="my-queries" element={!user ? <Navigate to={'/login'} /> : <MyQueries />} />
        <Route path="my-rulesets" element={!user ? <Navigate to={'/login'} /> : <MyRulesets />} />
        <Route
          path="process-dashboard/:process_template_id"
          element={!user ? <Navigate to={'/login'} /> : <ProcessDashboard />}
        />
        <Route
          path="process-dashboard/:process_template_id/report"
          element={!user ? <Navigate to={'/login'} /> : <ReportView />}
        />
        <Route path="iot/em/utilization" element={<Utilization />} />
        <Route
          path="iot/em/monitoring"
          element={!user ? <Navigate to={'/login'} /> : <Monitoring />}
        />
        <Route path="iot/em/config" element={<Config />} />
        {/* rework is going on.. set renderReworkForm = false to render older form */}

        <Route
          path="/process-data/:process_id/:activity_template_id"
          element={!user ? <Navigate to={'/login'} /> : <DataEntryPage />}
        />
        {/* Default Route */}
        <Route path="*" element={<Navigate to={'/'} />} />
      </Routes>
    </Layout>
  )
}

export default UserRoutes
